import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";


import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function GeoClimate() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/geoclimate/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  // function getRows() {
  //   if (typeof list !== "undefined" && list !== null && list.length > 0) {
  //     return list.map((row, index) => {
  //       let dateISO = new Date(row.time_uploaded);
  //       let formatted_datetime = dateToStringDate(dateISO);
  //       return (
  //         <StyledTableRow key={row.public_id}>
  //           <StyledTableCell>{index + 1}</StyledTableCell>
  //           <StyledTableCell>{row.title}</StyledTableCell>
  //           <StyledTableCell>{formatted_datetime}</StyledTableCell>
  //           <StyledTableCell>
  //             <IconButton
  //               aria-label="download"
  //               component="a"
  //               href={Config.api_domain + "/geoclimate/download/" + row.public_id}
  //               download
  //             >
  //               <Download />
  //             </IconButton>
  //           </StyledTableCell>
  //         </StyledTableRow>
  //       );
  //     });
  //   } else {
  //     return (
  //       <StyledTableRow key="no-data">
  //         <StyledTableCell colSpan={4} align="center">
  //           No Data Found
  //         </StyledTableCell>
  //       </StyledTableRow>
  //     );
  //   }
  //}

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Pengadaan Tahap I Perangkat Sistem Produksi Peta Terintegrasi</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
Berdasarkan Renstra BIG 2020-2024 dan RPJMN 2024-2029, BIG mempunyai kewajiban menyediakan peta skala besar. Dalam penyediaan percepatan peta skala besar perlu dilakukan pengembangan sistem produksi berbasis cloud melalui pemrosesan dan komputasi geospasial berkinerja tinggi (high-performance computing) untuk memfasilitasi proses penyelenggaraan IGD dalam kapasitas produksi skala besar nasional. Sistem produksi di pusat komputasi geospasial merujuk pada rangkaian proses, metode, dan teknologi yang digunakan untuk menghasilkan, mengelola, dan menyebarkan data serta informasi geospasial. Pada pusat komputasi geospasial, sistem produksi ini berfokus pada pemrosesan data spasial seperti peta, citra satelit, dan data geospasial lainnya dengan memanfaatkan kemampuan komputasi tinggi (high-performance computing) untuk menghasilkan produk yang dapat digunakan oleh berbagai aplikasi.
<br></br><br></br>
 <img 
  src="/concept.jpg" 
  alt="Concept" 
  style={{ display: "block", margin: "20px auto", maxWidth: "80%", borderRadius: "8px" }} 
/>

Sistem produksi peta terintegrasi yang akan dibangun terdiri dari beberapa bagian :
<br></br><br></br><b>1. Storage produksi yang tersentralisasi (hybrid, hot dan cold storage).</b><br></br><br></br>
Storage merupakan perangkat infrastruktur TIK yang berfungsi sebagai media penyimpanan data yang terhubung dengan sistem komputer melalui operasi input/output (I/O). Secara hirarki, storage terbagi menjadi 4 tingkatan, yaitu primary storage, secondary storage, tertiary storage, dan off-line storage. Saat ini BIG memiliki teknologi penyimpanan seperti Storage Area Network (SAN), Network Area Storage (NAS),  storage virtualization,  flash storage, dan object storage. 
<br></br><br></br>
<b>2. Sistem pengumpulan data/acquisition </b>
<br></br><br></br>a. Sistem penyimpanan data raster (foto udara, lidar, radar, ifsar)
Data raster (foto udara, lidar, radar, ifsar) yang diakuisisi dan dikumpulkan memerlukan sistem penyimpanan dan pengolahan data yang handal. Data tersebut akan diproses menjadi orthomosaik menggunakan Geospatial Data Abstraction Library (GDAL) dan Point Data Abstraction Library (PDAL). GDAL dan PDAL juga dapat membantu proses otomasi untuk transformasi data raster sehingga data yang dihasilkan sesuai dengan sistem koordinat yang digunakan. GDAL dan PDAL mampu menggabungkan banyak citra menjadi satu mozaik yang kontinu, yang sangat penting untuk menghasilkan peta skala besar
<br></br><br></br> 
b.Sistem penyimpanan data raster UAV (Nod ODM, Web ODM)
OpenDroneMap (ODM) adalah perangkat lunak sumber terbuka (open source) yang berfungsi sebagai alat fotogrametri yang digunakan untuk memproses citra udara yang berasal dari drone (UAV) menjadi peta dan model 3D. ODM biasanya digunakan untuk melakukan pemrosesan 2D images menjadi:
<br></br><br></br>● Classified Point Clouds
<br></br>●3D Textured Models
<br></br>●Georeferenced Orthorectified Imagery
<br></br>●Georeferenced Digital Elevation Models
<br></br>●Digital Surface Models
<br></br>●Digital Terrain Models
<br></br><br></br>ODM mendukung komputasi paralel dan memanfaatkan GPU yang ada supaya lebih berkinerja. ODM mendukung percepatan GPU untuk ekstraksi fitur SIFT, yang biasanya lebih cepat sekitar 2 kali lipat dibandingkan dengan CPU pada laptop/PC biasa. Perangkat ini memiliki fitur split-merge, yang secara signifikan mengurangi kinerja, tetapi memungkinkan komputer dengan jumlah RAM kecil untuk memproses kumpulan data yang besar. Rekomendasi resmi menyebutkan bahwa untuk memproses 2500 gambar ODM menggunakan resource memori sebesar 128 GB. Aplikasi ODM tersedia untuk Windows, Mac, dan Linux serta bekerja dalam command line, sehingga ideal digunakan untuk integrasi dengan perangkat lunak lainnya. Dalam kegiatan pemetaan skala besar ini, ODM akan memainkan peran penting dengan berbagai fungsinya yang meliputi pengolahan data UAV, transformasi data, pembuatan mozaik, orthorektifikasi, dan analisis spasial.       
<br></br><br></br>
<b>3. Sistem pengolahan data citra/lidar/radar (High Performance Computing)</b>
<br></br><br></br>a.Sistem pengolahan Pixel Factory
Sistem perangkat lunak Pixel Factory mampu melakukan pengolahan data hasil dari sensor citra satelit dan digital frame serta untuk seluruh modul yang terpasang pada sistem pengolahan data di BIG. Pixel Factory mendukung pelaksanaan kegiatan orthorektifikasi dalam penyediaan citra tegak resolusi sangat tinggi.
<br></br><br></br>b.Sistem pengolahan GXL
Sistem ini merupakan software pemrosesan data berbasis imaging dengan volume data yang besar yang dilakukan secara otomatis dan terdiri dari beberapa komponen utama, yaitu: Processing Server, Controller System, Web Portal (client) interface, Quality Assurance Computer. Komponen ini bekerja secara bersama-sama untuk memproses data secara efisien, berkecepatan tinggi, otomatis, terdistribusi secara otomatis pada masing-masing server.
<br></br><br></br>
<b>4. Sistem jaringan</b><br></br><br></br>
Adapun konsep jaringan saat ini yaitu jaringan tradisional dan SDN (Software-Defined Networking). Jaringan tradisional memiliki arsitektur terpusat di mana kontrol jaringan terdistribusi pada setiap perangkat keras, sedangkan SDN memiliki arsitektur terpusat dengan pemisahan lapisan kontrol dari perangkat keras. Kontrol jaringan dijalankan melalui controller terpusat.
<br></br><br></br><b>5. Sistem pengolahan data vektor</b>
<br></br><br></br>a.Pengolahan berbasis perangkat lunak berbayar
Basis data pengolahan data dan informasi geospasial saat ini yang tersedia adalah Single Database berbasis Oracle dan ArCGIS Spatial Data Engine (SDE). Dengan kebutuhan pemetaan skala besar untuk mendukung Land Administration, maka diperlukan modifikasi terkait sistem pengumpulan dan pengolahan, maka diperlukan penyesuaian terutama dengan teknologi ArcGIS High Performance Computing (HPC). Selain itu juga perlu peningkatan perangkat keras, perangkat lunak, lisensi yang mendukung proses pengolahan data vektor berbasis ArcGIS HPC serta tempat penyimpanan yang memadai.
<br></br><br></br>b.Pengolahan berbasis open source software
Proses pengolahan berbasis open source software, saat ini dilakukan secara individu dan belum dilakukan secara terpusat. Agar dapat melakukan pengolahan terpusat dan memfasilitasi, salah satunya pengolahan data peringatan dini banjir, maka perlu ditingkatkan melalui pengolahan open source software berbasis High Performance Computing (HPC) atau dapat dikatakan HPC berbasis open source. Hal ini memerlukan penambahan dan peningkatan perangkat keras, perangkat lunak untuk dapat mendukung proses pengolahan dan penyimpanan data hasil analisis peringatan dini banjir untuk menjadi data dukung analisis dampak perubahan iklim.
<br></br><br></br>
<b>6. System Clustered Database</b><br></br><br></br>
Basis data klaster yang tersedia saat ini adalah basis data penyebarluasan data dan informasi geospasial berbasis Oracle dengan interface ArcGIS Spatial Data Engine (SDE), basis data ini perlu ditingkatkan termasuk untuk mendukung sistem produksi baik dari segi kapasitas maupun performa untuk dapat menyimpan data yang lebih besar dan perlu dikaji untuk dapat menyimpan data dengan teknologi lain untuk kompatibilitas dengan sistem produksi dan penyebarluasan yang diperlukan pengguna.
<br></br><br></br>
<b>7. Cloud computing system</b><br></br><br></br>
Kebutuhan sistem produksi pemetaan dasar yang dibangun dapat diakses dari lokasi manapun dan kapanpun dengan didukung kesiapan komponen infrastruktur TI untuk memudahkan di dalam mengatur komponen tersebut, seperti mengelola server, perangkat penyimpanan fisik, dan peralatan jaringan dalam satu kesatuan sistem cloud computing. Teknologi untuk cloud computing dibutuhkan sampai tingkatan aplikasi, jadi perlu dilakukan kajian sejauh mana teknologi cloud computing yang sesuai dengan proses bisnis sistem produksi pemetaan skala besar, dari teknologi cloud computing seperti teknologi Infrastructure as a Service (IaaS), Platform as a Service (PaaS), Software as a Service (SaaS).
</p>

        {/* Unduh Section */}
        {/* <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer> */}

<h3>Procurement Timeline</h3>
<TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 500 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
        <StyledTableCell>Link</StyledTableCell>
        
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Pengumuman Pascakualifikasi</StyledTableCell>
        <StyledTableCell>19 Aug 2025, 16:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>9 Sep 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Download Dokumen Pemilihan</StyledTableCell>
        <StyledTableCell>19 Aug 2025, 16:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>11 Sep 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
        <StyledTableCell>21 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>28 Aug 2025, 09:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Upload Dokumen Penawaran</StyledTableCell>
        <StyledTableCell>21 Aug 2025, 09:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>11 Sep 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Pembukaan Dokumen Penawaran</StyledTableCell>
        <StyledTableCell>11 Sep 2025, 12:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>17 Sep 2025, 23:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Evaluasi Administrasi, Kualifikasi, Teknis, dan Harga</StyledTableCell>
        <StyledTableCell>11 Sep 2025, 12:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>17 Sep 2025, 23:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>7</StyledTableCell>
        <StyledTableCell>Pembuktian Kualifikasi</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 00:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>8</StyledTableCell>
        <StyledTableCell>Penetapan Pemenang</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 00:02 (GMT+7)</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 15:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>9</StyledTableCell>
        <StyledTableCell>Pengumuman Pemenang</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 15:01 (GMT+7)</StyledTableCell>
        <StyledTableCell>30 Sep 2025, 23:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>10</StyledTableCell>
        <StyledTableCell>Masa Sanggah</StyledTableCell>
        <StyledTableCell>1 Oct 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>14 Oct 2025, 11:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>11</StyledTableCell>
        <StyledTableCell>Surat Penunjukan Penyedia Barang/Jasa</StyledTableCell>
        <StyledTableCell>14 Oct 2025, 12:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>15 Oct 2025, 23:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>12</StyledTableCell>
        <StyledTableCell>Penandatanganan Kontrak</StyledTableCell>
        <StyledTableCell>27 Oct 2025, 00:00 (GMT+7)</StyledTableCell>
        <StyledTableCell>4 Nov 2025, 23:59 (GMT+7)</StyledTableCell>
        <StyledTableCell>
          <a 
            href="https://spse.inaproc.id/big" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <LinkIcon />
          </a>
        </StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>



        <p style={{ textAlign: "justify" }}>
  Informasi lebih lengkap mengenai paket Pengadaan Tahap I Perangkat Sistem Produksi Peta Terintegrasi dapat dilihat pada link{" "}
  <a href="https://spse.inaproc.id/big" target="_blank">
    spse.inaproc.id/big
  </a>.
</p>




      </Container>
    </div>
  );
}

export default GeoClimate;
